import { share, take } from 'rxjs/operators';
// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'actions' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').Notification} Notification
 * @typedef {import('vuex').ActionContext<State>} ActionContext
 */

/**
 * fetch account-specific configurations
 * @callback WatchNotificationsAction
 * @param {ActionContext} ctx
 * @param {any} opts
 * @returns {Promise<Notification[]>}
 *
 * @param {import('vuex').Store} store
 * @param {import('@mycure/sdk').CoreService} sdk
 * @returns {WatchNotificationsAction}
 */
export const watchNotifications = (store, sdk) => async (ctx, opts) => {
  const currentUser = await sdk.auth().currentUser();

  // reset state
  ctx.commit('setNotificationsSub', null);

  // process stream
  const query = { $sort: { createdAt: -1 }, seenBy: { $ne: currentUser.uid } };
  const stream = sdk.notifications().find(query).watch({ emitChangedItem: true }).pipe(share());
  const sub = stream.subscribe(notifications => notifications.forEach(notification => {
    switch (notification.__op) {
      case 'create':
      case 'update':
      default : {
        notification.seen = !notification.seenBy ? false : !!~notification.seenBy.indexOf(currentUser.uid);
        ctx.commit('updateInNotifications', {
          upsert: true,
          item: notification,
          addToNewNotifications: notification.__op === 'create'
        });
      }
    }
  }));
  ctx.commit('setNotificationsSub', sub);

  // return first emit
  return stream.pipe(take(1)).toPromise();
};

/**
 * @typedef {Object} MarkAsSeenActionOpts
 * @property {string} [notification] notification id to mark as unseen
 *
 * @callback MarkAsSeenAction
 * @param {ActionContext} ctx
 * @param {MarkAsSeenActionOpts} opts
 * @returns {Promise<void>}
 *
 * @param {import('vuex').Store} store
 * @param {import('@mycure/sdk').CoreService} sdk
 * @returns {MarkAsSeenAction}
 */
export const markAsSeen = (store, sdk) => async (ctx, opts) => {
  opts = Object.assign({}, opts);

  let query = opts.notification;
  if (!query) {
    const currentUser = await sdk.auth().currentUser();
    query = { seenBy: { $ne: currentUser.uid } };
  }
  await sdk.notifications().update(query, { seen: true });
};

/**
 * @callback ClearNewNotificationsAction
 * @param {ActionContext} ctx
 * @param {any} opts
 * @returns {Promise<void>}
 *
 * @param {import('vuex').Store} store
 * @param {import('@mycure/sdk').CoreService} sdk
 * @returns {ClearNewNotificationsAction}
 */
export const clearNewNotifications = (store, sdk) => async (ctx, opts) => {
  if (ctx.state.notificationsNew.length) ctx.commit('clearNotificationsNew');
};
